// extracted by mini-css-extract-plugin
module.exports = {"tabComp":"tabComp___QeXYr","tabBox":"tabBox___3_lQ7","tabComponent":"tabComponent___34KUc"};